// extracted by mini-css-extract-plugin
export var quillEditor = "_gq-1";
export var variable = "_gq-0";